import {
  translateSite as publicTranslateSite,
  getSiteTranslatablesProperties as publicGetSiteTranslatablesProperties,
} from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const translateSite: MaybeContext<
  BuildRESTFunction<typeof publicTranslateSite> & typeof publicTranslateSite
> = /*#__PURE__*/ createRESTModule(publicTranslateSite);
export const getSiteTranslatablesProperties: MaybeContext<
  BuildRESTFunction<typeof publicGetSiteTranslatablesProperties> &
    typeof publicGetSiteTranslatablesProperties
> = /*#__PURE__*/ createRESTModule(publicGetSiteTranslatablesProperties);

export {
  SiteTranslatableProperties,
  ApplicationTranslatableProperties,
  TranslateSiteRequest,
  Locale,
  TranslateSiteResponse,
  GetSiteTranslatablesPropertiesRequest,
  GetSiteTranslatablesPropertiesResponse,
  TranslateSiteOptions,
  GetSiteTranslatablesPropertiesOptions,
} from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.universal.js';
